import { Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useMe } from "@/context/MeContext";
import { startPlanPath } from "@/lib/api";
import AppShell from "@/components/AppShell";
import { HELPLINES, OUTSIDE_NZ } from "@/lib/content";

const OverseasHelpline = () => {
  const { me } = useMe();
  if (me?.profile?.area !== OUTSIDE_NZ) return null;
  return (
    <p className="mt-5 rounded-xl bg-alabaster p-4 text-[15px] text-charcoal" data-testid="overseas-helpline">
      Outside New Zealand: find a free helpline near you at{" "}
      <a href="https://findahelpline.com" target="_blank" rel="noopener noreferrer" className="font-medium underline underline-offset-4">findahelpline.com</a>.
    </p>
  );
};

export const Helplines = () => {
  const { me } = useMe();
  const list = me?.profile?.area === OUTSIDE_NZ ? HELPLINES.filter((h) => h.name !== OUTSIDE_NZ) : HELPLINES;
  return (
  <>
  <OverseasHelpline />
  <ul className="mt-5 divide-y divide-rule" data-testid="helplines-list">
    {list.map((h) => (
      <li key={h.name} className="py-3 flex flex-col sm:flex-row sm:items-baseline sm:gap-3">
        <a href={h.href} className="font-medium text-charcoal underline-offset-4 hover:underline" target={h.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">{h.name}</a>
        <span className="text-ink-soft text-[15px]">{h.detail}</span>
      </li>
    ))}
  </ul>
  </>
  );
};

export default function Ready() {
  const nav = useNavigate();
  const { me } = useMe();
  const [path] = useState(() => startPlanPath(me));
  if (path !== "/ready") return <Navigate to={path} replace />;
  return (
    <AppShell nav={false}>
      <div className="fade-in" data-testid="ready-page">
        <p className="eyebrow mb-3">Are you ready?</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl leading-tight">Clear the noise, let's begin.</h1>
        <div className="ahu-card mt-10 p-6 sm:p-8">
          <h2 className="text-xl">Before you begin</h2>
          <p className="mt-4 text-ink leading-relaxed">AHU is a self-reflection tool. It isn't therapy, counselling or a crisis service.</p>
          <p className="mt-3 text-ink leading-relaxed">If you're doing it really tough, please reach out to someone you trust, or free call or text 1737 any time to talk with a trained counsellor. In an emergency, call 111.</p>
          <p className="mt-3 text-ink leading-relaxed">If anything you write suggests you may be at risk, AHU will show you where to get support and let our safety contact know, so we can meet our duty of care.</p>
          <Helplines />
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <button className="btn-gold sm:min-w-[240px]" onClick={() => nav("/questions")} data-testid="ready-begin-btn">I understand, let's begin</button>
          <button className="btn-quiet justify-center" onClick={() => nav("/")} data-testid="ready-not-now-btn">Not right now</button>
        </div>
      </div>
    </AppShell>
  );
}
